import { render, staticRenderFns } from "./DashboardEnlace.vue?vue&type=template&id=06e5fb76&scoped=true"
import script from "./DashboardEnlace.vue?vue&type=script&lang=js"
export * from "./DashboardEnlace.vue?vue&type=script&lang=js"
import style0 from "./DashboardEnlace.vue?vue&type=style&index=0&id=06e5fb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5fb76",
  null
  
)

export default component.exports